export const LIST_APPS = "LIST_APPS"
export const LIST_ADVERTISERS = "LIST_ADVERTISERS"

export const END_URL = {
    APPLICATION : '/application/all',
    ADVERTISERS : 'accounts',
}
export const TYPE = {
    SUCCESS: 'success',
    ERROR: 'error',
}

export const VALIDATION = {
    SYSTEM_ERROR: "System Error"
}